import { SECTION_TRACK_STATUSES, ESectionTrackStatus } from '@constants';
import { Select } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './SectionTrackingSelector.styles';
import { getSectionTrackingStyles } from './utils/getSectionTrackingStyles';

import { Icon } from '@/components/Icon';

type Props = {
  id?: string;
  value?: ESectionTrackStatus;
  onChange?: (value: ESectionTrackStatus) => void;
  isLoading?: boolean;
  disabled?: boolean;
};

export const SectionTrackingSelector: React.FC<Props> = ({
  id,
  value,
  onChange,
  isLoading,
  disabled = false
}) => {
  const { t } = useTranslation();
  const [menuOpen, setMenuOpen] = useState(false);

  const options = useMemo(
    () =>
      SECTION_TRACK_STATUSES.map(status => ({
        label: t(status),
        value: status
      })),
    [SECTION_TRACK_STATUSES]
  );

  const { backgroundColor, color, iconColor } = useMemo(
    () => getSectionTrackingStyles(value),
    [value]
  );

  return (
    <Wrapper id={id} backgroundcolor={backgroundColor} color={color}>
      <Select
        open={menuOpen}
        onOpenChange={setMenuOpen}
        disabled={disabled}
        options={options}
        onChange={val => {
          onChange?.(val);
          setMenuOpen(false);
        }}
        onClick={e => e.stopPropagation()}
        defaultValue={ESectionTrackStatus.NOT_STARTED}
        suffixIcon={
          <Icon i="ChevronDown" color={iconColor} onClick={() => setMenuOpen(prev => !prev)} />
        }
        value={value}
        loading={isLoading}
        size="small"
        style={{ minWidth: '120px' }}
      />
    </Wrapper>
  );
};
